import { httpsCallable } from 'firebase/functions';
import { functions } from '../config/firebase';

export interface AdminConfig {
  adminEmails: string[];
}

export const getAdminStatus = async (): Promise<boolean> => {
  const callable = httpsCallable(functions, 'getAdminStatus');
  const result = await callable({});
  const data = result.data as any;
  return !!data?.isAdmin;
};

export const getAdminConfig = async (): Promise<AdminConfig> => {
  const callable = httpsCallable(functions, 'getAdminConfig');
  const result = await callable({});
  const data = result.data as any;
  return { adminEmails: Array.isArray(data?.adminEmails) ? data.adminEmails : [] };
};

export const setAdminConfig = async (adminEmails: string[]): Promise<void> => {
  const callable = httpsCallable(functions, 'setAdminConfig');
  await callable({ adminEmails });
};
